import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

import {map,tap} from 'rxjs/operators';
import { AuthService } from '../services/auth/auth.service';
@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {

  constructor(
    private router: Router,
    public _auth: AuthService,

  ) {}




  private modifyBody = async (body: any, skipRefresh: boolean = false) => {
    try {
      // No refrescar si estamos en logout
      if (skipRefresh) {
        console.log('🔴 INTERCEPTOR: Skip refresh activado, no refrescando token');
        return;
      }
      
      const token: any = localStorage.getItem('x-token');
      
      // No refrescar token si no existe (estamos en logout)
      if(!token) {
        console.log('🔴 INTERCEPTOR: No hay token, saltando refresh');
        return;
      }
      
      // No refrescar si el servicio está haciendo logout
      if(this._auth.getIsLoggingOut()) {
        console.log('🔴 INTERCEPTOR: Logout en progreso, saltando refresh');
        return;
      }
      
      if(!body?.x_token){
        let resp = await this._auth.refresh_token({"x_token":token});

        if(resp?.x_token){
          console.log('🔴 INTERCEPTOR: Guardando token refrescado');
          localStorage.setItem('x-token',resp?.x_token)
        }
      }
    } catch (error:any) {
      console.log('🔴 INTERCEPTOR: Error en modifyBody:', error);
    }
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token: any = localStorage.getItem('x-token');
    let request = req;

    // No agregar token automático si es una llamada del simulador
    const skipAuthInterceptor = req.headers.get('X-Skip-Auth-Interceptor');
    
    // Verificar si la request ya tiene authorization custom (para setup 2FA sin localStorage)
    const hasCustomAuth = req.headers.has('authorization');

    if (token && !skipAuthInterceptor && !hasCustomAuth) {
      // Solo agregar authorization si NO hay uno custom
      request = req.clone({
        setHeaders: {
        // authorization: `Bearer ${ token }`
           authorization: `${ token }`

        }
      });
    } else if (hasCustomAuth && !token) {
      // Si ya tiene authorization custom y NO hay token en localStorage, dejar pasar
      console.log('🔓 Interceptor: Request ya tiene authorization custom, no modificando headers');
      request = req;
    }

    return next.handle(request)
    .pipe(map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        // Verificar si debemos saltar el refresh
        const skipRefresh = request.headers.get('X-Skip-Token-Refresh') === 'true';
        this.modifyBody(event.body, skipRefresh);
      }
      return event;
  })).pipe(
    catchError((resp: HttpErrorResponse) => {
      // No cerrar sesión si es una llamada del simulador
      const skipAuthInterceptor = request.headers.get('X-Skip-Auth-Interceptor');
      
      if (resp.status === 401 && !skipAuthInterceptor) {
        // Solo hacer logout si el 401 viene de NUESTRO backend, no de APIs externas
        const isOwnBackend = request.url.startsWith(environment.BASE_LA);
        
        if (isOwnBackend) {
          console.log('🔴 INTERCEPTOR: Error 401 del backend propio, cerrando sesión. URL:', request.url);
          
          // Verificar si la sesión fue invalidada (expirada o cerrada desde otro dispositivo)
          if (resp.error?.code === 'SESSION_INVALIDATED' || resp.error?.sessionClosed) {
            sessionStorage.setItem('sessionClosedMessage', resp.error?.msg || 'Tu sesión ha expirado o fue cerrada desde otro dispositivo');
          }
          
          this.router.navigate([environment.logoutRoute], {});
        } else {
          console.log('🔴 INTERCEPTOR: Error 401 de API externa (ignorado para logout). URL:', request.url);
        }
      }

      return throwError(() => resp);

    })
  );



/*


    return next.handle(request).pipe(
      catchError((resp: HttpErrorResponse) => {
        if (resp.status === 401) {
          this.router.navigate([environment.logoutRoute], {});
        }

        return throwError(() => resp);

      })
    );*/
  }

}
